export default __webpack_public_path__ + "static/media/LENS_CULINARIS_TEKAY_complete_7.99fb7b8b.jpg";